import { render } from "./NoTrailersAvailable.vue?vue&type=template&id=278b4803&scoped=true&ts=true"
import script from "./NoTrailersAvailable.vue?vue&type=script&lang=ts"
export * from "./NoTrailersAvailable.vue?vue&type=script&lang=ts"

import "./NoTrailersAvailable.vue?vue&type=style&index=0&id=278b4803&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-278b4803"]])

export default __exports__